import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { groupReducer } from './group.reducer'
import { EffectsModule } from '@ngrx/effects'
import { GroupEffects } from './group.effects'

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('group', groupReducer), EffectsModule.forFeature([GroupEffects])],
  declarations: [],
})
export class SignatureGroupStoreModule {}
